import { render, staticRenderFns } from "./PromoCard.vue?vue&type=template&id=17dd320a&scoped=true&"
import script from "./PromoCard.vue?vue&type=script&lang=ts&"
export * from "./PromoCard.vue?vue&type=script&lang=ts&"
import style0 from "@/components/private/home-page/promocard.css?vue&type=style&index=0&id=17dd320a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dd320a",
  null
  
)

export default component.exports